module.exports = __webpack_public_path__ + "static/media/activity-map.d866cd3c.png";